/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {bus} from '@/main';

export default {
  name: 'header-before-login',
  components: {},
  props: [],
  data () {
    return {
      togglePopup: false
    }
  },
  computed: {

  },
  mounted () {
    $(document).ready(function(){
    $(".Q_btn").click( function(){
      $(window).scrollTop(0);
      $(".firstbanner-in").toggleClass("active");
      $("body").toggleClass("login_box_hide");
    });
    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".Q_btn, .welcome_popup .light_bg_section").length) {
      $("body").find(".firstbanner-in").removeClass("active");
      $("body").removeClass("login_box_hide");
      }
    });
  });
  },
  methods: {
    signUpFormShow(){
      $(window).scrollTop(0);
      setTimeout(()=>{
        bus.$emit('showSignUpForm', true);
        $('body').addClass('registration_form')
      },1)
    },
    handleScroll() {
      let header = document.querySelector(".header_fix");
      let covid_19_popup = document.querySelector(".covid_19_popup");
      if (window.scrollY > 30 && !header.className.includes('darkBg')) {
        header.classList.add('darkBg');
        if(covid_19_popup){
          covid_19_popup.classList.add('moved_to_top_icon');
        }
        } else if (window.scrollY < 30) {
          header.classList.remove('darkBg');
          if(covid_19_popup){
          covid_19_popup.classList.remove('moved_to_top_icon');
          }
        }
    },
    togglePopupFunction(){
      this.togglePopup = !this.togglePopup;
      bus.$emit('togglePopipOverlay', this.togglePopup);
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  
}
